const blogdata = [
  {
    id: 1,
    slug: "afroswing",
    title: "Afroswing: The Rise, The Decline, The Revival?",
    author: "Brian Omowumi",
    date: "04/09/2023",
    featured: false,
    intro:
      "The roots of Afroswing can be traced back to London's multicultural neighbourhoods, such as Brixton, Tottenham, and Hackney, where a diverse group of artists began experimenting with combining various musical influences. Here, African and Caribbean sounds blended with UK urban music genres like grime and garage during this time. The result was a fresh and innovative sound that resonated with a growing audience seeking something new and exciting. ",

    complete: (
      <>
        The roots of Afroswing can be traced back to London's multicultural
        neighbourhoods, such as Brixton, Tottenham, and Hackney, where a diverse
        group of artists began experimenting with combining various musical
        influences. Here, African and Caribbean sounds blended with UK urban
        music genres like grime and garage during this time. The result was a
        fresh and innovative sound that resonated with a growing audience
        seeking something new and exciting. <br /> <br />
        To delve into the heart of Afroswing and its impact, I had the pleasure
        of sitting down for a brief interview with the talented artist Gwamz, a
        rising star in the genre making waves with his distinct sound and style.
        Coming off the success of his last single, “Last Night”, I interviewed
        the 22-year-old self-proclaimed “Afro-fusion” artist to pick his brains
        on the music scene and his overall journey to date: Brian: How did your
        artistic journey into Afroswing start?
        <br /> <br />
        Gwamz: I started off as a producer, then I got into rapping. I was
        around 16/17 when I started playing around with vocals and recording
        audio on my laptop. I had no mic, so I had to bring the laptop close to
        my mouth to record. I was always good with melodies, even at my work
        studio. If they needed a melody, they would come to me. I eventually
        decided to stop being a rapper and fully commit to going down the
        melodic avenue, and that's how I ended up doing Afroswing.
        <br /> <br /> Brian: Are there any specific things you aim to achieve
        through your Afroswing music?
        <br /> <br /> Gwamz: I like to create stories in my music, so I want the
        people who listen to my songs to feel like they are the main character
        in the song. I also want them to feel positive emotions when they listen
        to me.
        <br /> <br /> Brian: What advice would you give aspiring artists
        interested in pursuing a career in the Afroswing genre?
        <br /> <br /> Gwamz: Be yourself, don’t copy someone else’s blueprint.
        What works for someone else may not work for you. Being true to who you
        are attracts people to your sound that like you for you. So, the best
        thing to do is to find your own lane and hone your sound.
        <br /> <br />
        Brian: How do you feel about the representation of Afroswing in
        mainstream media and its recognition within the music industry?
        <br /> <br />
        Gwamz: It’s definitely growing, and I feel like it's gonna be bigger
        than anything else in the next ⅔ years. In the past year or so, we have
        seen how much more global Afroswing has become, and that's also due to
        the rising global popularity of Afrobeats. Next year, summer is going to
        be amazing for the Afro-swing scene, and there are a few people to look
        out for, such as Jaybiz and Cxrno.
        <br /> <br />
        Brian: What plans do you have for music in the coming months?
        <br /> <br />
        Gwamz: The plan is to explore a bit more. Honestly, I want my sound to
        be heard globally, so it’s a process. I don’t want to be dropping too
        much, as I take every song release seriously. You’ve got to stand out
        with your marketing especially.
      </>
    ),

    img: "https://d1g9iww9o5ioh1.cloudfront.net/blog/afroswing-article-img.webp",
    authorimg: "https://d1g9iww9o5ioh1.cloudfront.net/blog/brianpp.webp",
    goback: "/blog#blogafroswing",
  },
  {
    id: 2,
    slug: "mymind",
    title: "Osas finds clarity in Chaos on Soulful New Track 'My Mind'",
    author: "Brian Omowumi",
    date: "22/05/2025",
    featured: false,
    intro: (
      <>
        Emerging from the vibrant music scene of South East London, Osas, a
        21-year-old artist with deep roots in Benin City, Nigeria — is set to
        release his latest single, My Mind, on May 23, 2025. Following his
        emotionally charged February drop Intentions 2, this new offering dives
        even deeper into the raw realities of chasing success. <br /> <br />
        My Mind is emotional, introspective, and reflective. It is a deeply
        personal track that
        <br />
      </>
    ),
    complete: (
      <>
        Emerging from the vibrant music scene of South East London, Osas, a
        21-year-old artist with deep roots in Benin City, Nigeria — is set to
        release his latest single, My Mind, on May 23, 2025. Following his
        emotionally charged February drop Intentions 2, this new offering dives
        even deeper into the raw realities of chasing success. <br /> <br />
        My Mind is emotional, introspective, and reflective. It is a deeply
        personal track that captures the struggle, sacrifice, and determination
        behind the scenes of the hustle. It's a cry for balance in a world that
        constantly demands more, and a celebration of resilience in the face of
        burnout. Osas isn’t just telling his story — he’s inviting us into the
        mental tug-of-war that many young creatives can relate to and silently
        endure. It’s almost a rite of passage for those in the creative scene.
        <br /> <br />
        Lyrically, the song draws from Osas’ real-life experiences as an
        independent artist navigating ambition, faith, and fatigue. The track
        captures a very human moment: the act of falling in love with the
        process, even when it gets heavy. Personally, the song encapsulates the
        essence of being a creator; you can not truly love the success that can
        come from your journey if you don’t also learn to love and appreciate
        the inevitable hard times.
        <br /> <br /> Musically, My Mind blends the warmth of Afrobeat with rich
        R&B undertones, creating a soundscape that mirrors the track’s emotional
        weight. Around the 46-second mark, the unexpected entry of the talking
        drum took me by surprise — in the best way possible. As a fellow
        Nigerian, that moment felt like home. It’s a small but powerful cultural
        anchor in a song that’s otherwise filled with sonic experimentation. The
        production, handled by the talented F1, gives Osas the perfect canvas to
        explore his sound and emotions.
        <br /> <br /> Osas’ journey began humbly on SoundCloud, where his
        genre-bending approach and heartfelt writing began to catch attention.
        His 2023 EP If It Was Up To Me is essential listening; a body of work
        that explores love, identity, and inner conflict with both maturity and
        musical finesse. Standout tracks like “Bini Tears” and “Peace” speak to
        his ability to turn personal reflections into universal themes.
        <br /> <br /> Osas is part of a new wave of artists redefining what it
        means to be global. He effortlessly bridges his Nigerian heritage with
        his South London upbringing, creating music that’s as diasporic as it is
        authentic. His work doesn’t just entertain — it speaks. It heals. It
        inspires.
        <br /> <br /> I’ve said it before and I’ll repeat it: Osas is an artist
        to lock into. And with My Mind, he once again proves that his growth is
        only beginning. If this is a glimpse of what’s to come, the excitement I
        have for his future work only continues to grow."
      </>
    ),
    img: "https://d1g9iww9o5ioh1.cloudfront.net/blog/mymind-article-img.webp",
    authorimg: "https://d1g9iww9o5ioh1.cloudfront.net/blog/brianpp.webp",
    goback: "/blog#blogmymind",
    fixed_content_title: "Listen now:",
    fixed_spotify:
      "https://open.spotify.com/track/55r262luMGv5a9f2L4P0Zq?si=h2MwRAf0TJOMwyDL_KY2Xg",
    fixed_apple_music:
      "https://music.apple.com/gb/album/my-mind/1811716685?i=1811716686",
    fixed_youtube: "https://youtu.be/ts-oSRTBVMQ?si=K8-YE-dBpD5jhUCP",
  },
  {
    id: 3,
    slug: "sweet&gully",
    title: "No features. No shortcuts. All him.",
    author: "Brian Omowumi",
    date: "21/02/2026",
    featured: false,
    intro: (
      <>
        With the release of Sweet & Gully, Skarz steps into the mainstream with
        nothing but conviction, clarity and a clear sense of self.
        <br /> <br />
        This is not just a debut album. It is a statement of intent. In a
        climate where emerging artists often rely on heavy features and viral
        moments to accelerate visibility, Skarz has chosen the harder route:
        betting on identity over industry shortcuts. Sweet & Gully feels less
        like an introduction and more like a declaration.
      </>
    ),
    complete: (
      <>
        With the release of Sweet & Gully, Skarz steps into the mainstream with
        nothing but conviction, clarity and a clear sense of self.
        <br /> <br />
        This is not just a debut album. It is a statement of intent. In a
        climate where emerging artists often rely on heavy features and viral
        moments to accelerate visibility, Skarz has chosen the harder route:
        betting on identity over industry shortcuts. Sweet & Gully feels less
        like an introduction and more like a declaration.
        <br /> <br />
        Skarz is a fully independent artist whose rise has been built not on
        hype, but on execution. Records like ‘My Mind’, ‘You’ and ‘Turn Up The
        Function’ have been key moments in his growing body of work. Every
        release has felt intentional, and it has paid off. The loyal and rapidly
        expanding fan base has been responding in real time. This was especially
        evident when he sold out his headline show as an independent artist in
        just nine minutes. In October last year, he opened up for Gabzy on his
        world tour at Camden Roundhouse in front of five thousand people. His
        performance left a lasting impression, garnering serious industry
        interest as well as co-signs from influential figures including Odeal,
        Ruger and MOBO Award winner Mnelia, among a few others.
        <br /> <br />
        In his radio appearance on Capital Xtra, he explained that he did not
        want to release something simply because people were asking for a
        project. He did not want a throwaway. He made it clear that he
        understands people will connect with him more when he tells a story.
        Sweet & Gully was released to show all sides of the individual we know
        as Skarz. He wants us to see the “struggle, grit and pressure” that
        comes with being an artist, while still revealing that sweet side to his
        character. Having previously mentioned that he finds projects boring
        when only one thing is happening throughout, he described this body of
        work as a “rollercoaster of emotions.”
        <br /> <br />
        There is a clear structure and intent behind this project. Ten songs. No
        features. Five melodic, emotion-evoking tunes and five hunger-fuelled
        records that show grit and pressure. No crossover and no compromise.
        Skarz explores the dynamic of vulnerability and dominance within an
        artist as well as how that tension reveals itself in the music. Sweet &
        Gully shows that softness does not cancel strength, and edge does not
        erase control. It is the same body of work that delivers ‘Pressure’,
        showcasing his confidence and commanding presence, while also giving us
        ‘Divine’, a fan favourite, which highlights Skarz’s ability to deliver
        emotionally driven records with depth and finesse.
        <br /> <br />
        On ‘Pressure’, the production is stripped yet commanding. The drums feel
        deliberate, almost marching, giving him the space to deliver with
        authority. His cadence is sharp, controlled and assured. There is no
        sense of doubt in his delivery. It is hunger — but refined hunger. Not
        desperation. Determination. The hook does not beg for attention; it
        commands it.
        <br /> <br />
        In contrast, ‘Divine’ slows the tempo and leans into melody. Here, his
        vocal layering carries emotion without sounding forced. The
        vulnerability feels natural, not manufactured. There is a softness in
        his tone that proves he understands restraint. Rather than overpowering
        the instrumental, he sits within it. That balance is what makes the
        record replayable. Even in the sequencing of the album, the transitions
        feel intentional. The gritty records do not overpower the melodic ones;
        they sharpen them. The emotional songs feel more honest because of the
        harder ones. The harder ones feel more grounded because of the emotional
        depth. That duality is where the album finds its strength. A duality
        that is also clearly portrayed in the artwork.
        <br /> <br />
        All ten tracks are produced by regular collaborator Wizxrd, who brings a
        cultural authenticity that has resonated with listeners. Songs like
        ‘You’ and ‘My Mind’ have garnered over 1.5 million streams on their own.
        With no additional features, it feels like an album built around a clear
        artistic and creative vision. This is especially important as it shows
        that, even in the early stages of his career, Skarz values authenticity
        over commercial strategy. He has not fallen victim to industry pressure.
        This is him saying, I am enough.
        <br /> <br />
        On the flip side, some may argue that the lack of features limits the
        exposure he could have gained. However, for a debut album, something
        deeply personal and intimate, the decision makes sense. In my opinion,
        it strengthens the cohesiveness of the project. An artist should be
        allowed to build their foundation without rushing into expansion. Build
        a strong foundation. Establish a loyal fan base. Then branch out.
        <br /> <br />
        If there is any room for growth, it may lie in pushing the sonic
        experimentation slightly further. While the cohesion is strong, there
        are moments where the melodic records sit within a similar tempo pocket.
        A bolder shift in production or structure on one or two tracks could
        have elevated the emotional contrast even further. Doing this alongside
        his already amazing delivery could elevate the project to the next
        level. However, for a debut rooted in identity, restraint may well have
        been the point.
        <br /> <br />
        The manner in which this debut has been executed has emphasised one
        thing clearly. This is not another up-and-coming artist testing the
        waters. This is an artist ready to define his own path from the get-go.
        Skarz is not experimenting with his identity in public. He knows who he
        is. This album is a foundation. And foundations, when built properly, do
        not crack under pressure. If this is the starting point, calling the
        future promising would be an understatement.
      </>
    ),
    img: "https://d1g9iww9o5ioh1.cloudfront.net/blog/sweet.webp",
    authorimg: "https://d1g9iww9o5ioh1.cloudfront.net/blog/brianpp.webp",
    goback: "/blog#blogsweet&gully",
    fixed_content_title: "Listen now:",
    fixed_spotify:
      "https://open.spotify.com/album/3qvqEJMhHOL3PwRXD2aymM?si=2X6rrQ7-T1Cv_CCPpp50Wg",
    fixed_apple_music:
      "https://music.apple.com/gb/album/sweet-gully/1872466367",
    fixed_youtube:
      "https://www.youtube.com/watch?v=C8xb2IrX7Sg&list=RDC8xb2IrX7Sg&start_radio=1",
  },

  {
    id: 4,
    slug: "summerintosoundtrack",
    title: "Pressed Play and felt the Sun: Osas turns Summer into a Soundtrack",
    author: "Brian Omowumi",
    date: "11/03/2026",
    featured: true,
    intro: (
      <>
        With the weather as bad as it is, this is the perfect time to uncover
        the true sounds of Summer. We all know that summer feeling; warmth on
        the skin, evenings filled with laughter and moments that seem to last
        longer than the season itself. With Sounds of Summer, Osas manages to
        capture that feeling and put it into an EP that feels both nostalgic and
        present.
      </>
    ),
    complete: (
      <>
        With the weather as bad as it is, this is the perfect time to uncover
        the true sounds of Summer. We all know that summer feeling; warmth on
        the skin, evenings filled with laughter and moments that seem to last
        longer than the season itself. With Sounds of Summer, Osas manages to
        capture that feeling and put it into an EP that feels both nostalgic and
        present.
        <br />
        <br />
        Sounds of Summer is an EP released in early August by up-and-coming
        artist Osas. Sounds of Summer marks the beginning of the “Sounds of..”
        series. This particular installment showcases the vibrant energy of
        Afrobeats, Afro-fusion, and Alté. Released at the peak of 2025 summer,
        this 4 track EP (originally a 3 track EP), excels at encapsulating the
        warmth and vitality of summer with its infectious, upbeat rhythms.
        <br />
        <br />
        Sounds of Summer leans into a mellow production, courtesy of long time
        collaborator F1 and Qisretired. Soft percussion and subtle Afro-inspired
        rhythms and laid back melodies set the tone and more importantly, let
        the music do the talking. It almost allows for the space needed to
        reflect on whatever it is that one has in mind
        <br />
        <br />
        One thing I have personally loved about Osas’ navigation of his music
        career is his ability to be authentic and intentional. At no point, have
        I ever felt like he was chasing a trend with his music. Evident
        especially in this EP, Osas focuses on the atmosphere his songs create.
        The natural, unforced nature of the songs as well as the ease at which
        each song flows into each other, makes the EP as a whole, very cohesive.
        This is an EP best experienced as a full listen.
        <br />
        <br />
        Being Nigerian myself, Kilowenso instantly caught my attention. I have
        to admit, I laughed when I realised the song was literally called “What
        you saying?”. It’s such a simple phrase, but one that carries so much
        familiarity, especially within British slang and everyday conversation.
        Instantly, it feels like the opening line to a moment, a conversation,
        or the beginning of something that might only last for a season. What
        makes it even more poignant to me is how many summer romances probably
        started with those exact words. That casual opener, thrown out almost
        playfully, yet carrying the possibility of something more. For me, this
        song encapsulates that exact feeling of yearning that often comes with a
        summer fling; the curiosity, the anticipation, and the quiet hope that
        something fleeting might turn into something memorable. The choice of
        instrumentals only amplifies that atmosphere. There’s a lightness to the
        production that mirrors warm evenings and spontaneous conversations, the
        kind that stretch longer than you expect. It sits comfortably within the
        broader soundscape of summer music, but still manages to feel personal,
        almost like a soundtrack to those small, unplanned moments that end up
        defining the season.
        <br />
        <br />
        Sounds of Summer isn’t just an EP - it is the perfect example of an
        artist successfully capturing a feeling, a mood, a memory, a moment in
        sound. The songs that are often unforgettable to us are those that
        successfully manage to evoke emotion out of the listener’s. I mentioned
        in my previous article that Osas was an artist to watch out for and he
        has proven that point.
        <br />
        <br />
        Summer will pass, but the feelings and emotions captured won’t.
      </>
    ),
    img: "https://d1g9iww9o5ioh1.cloudfront.net/blog/summerintosound.webp",
    authorimg: "https://d1g9iww9o5ioh1.cloudfront.net/blog/brianpp.webp",
    goback: "/blog#featuredid",
    fixed_content_title: "Listen now:",
    fixed_spotify:
      "https://open.spotify.com/album/5zLFdQ4AEQQnXvobzEWSQU?si=aNGpg7HDTWioEWFcRC6cwQ",
    fixed_apple_music:
      "https://music.apple.com/gb/album/sounds-of-summer-ep/1825503075",
    fixed_youtube:
      "https://www.youtube.com/playlist?list=OLAK5uy_mWos_xAXrCHpRGyMiPlwcxhCw7JtEAvlc",
  },
];
export default blogdata;
